<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I7gqzA/tc-custom/9781642793079.jpg?1700367366004" alt="This image is the cover for the book Broken Lenses, Broken Lenses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken Lenses, Broken Lenses
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Broken Lenses</i> reveals the truth of who God made people to be and the freedom that results from living out that truth.</b><p> A rape survivor, Emily Bernath’s life quickly turned away from having everything to feeling hopelessness and worthlessness. It was during that time of being open about her experience that it became apparent to her just how many other people experience those same feelings and so easily allow things that aren’t true about them define who they are. <i>Broken Lenses</i> stems from a passion to take outreach to the next level. Inside, Emily identifies some of the most popular lies people believe about themselves and pulls out the 12 biggest Biblical truths Christians should embrace in their own lives, such as “I am lovable” and “I am not a failure.”</p><p> With her scientific background and tell-it-how-it-is approach, Emily analyzes and connects each truth to God’s word through a few key lessons for each truth. She calls out the ways in which the enemy prevents people from believing these truths about themselves and what it looks like to truly embrace each of these truths. Ultimately, <i>Broken Lenses</i> helps readers achieve a more intimate relationship with God and the freedom that He desires each of his children to live in.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Bernath
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a364e39